import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ExportOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Modal, Tooltip, Tag, DatePicker, Button, Alert, Typography } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import TextTruncate from 'react-text-truncate';
import { checkPermission } from '@/utils/permission';
import { cleanObject, stripHtml, repeatPhoneNumber, isValidDate, profileStatusOptions, renderProfileStatus } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';
import HandlePhoneNumber from '@/components/HandlePhoneNumber';
import { getCustomerProspects, deleteCustomerProspects, exportCustomerProspects, getCustomerProspect, getCustomerProspectNames } from '@/redux/actions/customerProspectsActions';
import { getListWards } from '@/redux/actions/regionsActions';
import BaseSelect from '@/components/Elements/BaseSelect';
import DynamicTable from '@/components/DynamicTable';
import CreatedAtCell from '@/components/CreatedAtCell';
import CustomerProspectForm from './CustomerProspectForm';
import CustomerProspectDetail from './CustomerProspectDetail';
import ImportExcelForm from './ImportExcelForm';
import CreateProfileForm from './CreateProfileForm';

const { confirm } = Modal;
const { RangePicker } = DatePicker;
const { Paragraph } = Typography;
const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/customer-prospects',
        breadcrumbName: 'Khách hàng tiềm năng',
    },
]

class CustomerProspectList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isLoadingExport: false,
            selectedRowKeys: [],
            isOpenForm: false,
            currentItem: null,
            isOpenDetail: false,
            loadingDetail: false,
            importResponseMessage: null,
            importResponseType: null,
            isOpenFormImport: false,
            wards: [],
            isOpenFormCreateCustomer: false,
            currentRecord: null
        }
    }

    componentDidMount() {
        const query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);

        if (query.province_code) {
            this.props.getListWards({ province_code: query.province_code })
                .then(res => this.setState({ wards: res.data }));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            const query = qs.parse(this.props.location.search.slice(1));
            this.loadData(query);
        }
    }

    loadData(query) {
        this.setState({ isLoading: true });

        Promise.all([
            this.props.getCustomerProspects(query),
            this.props.getCustomerProspectNames(),
        ]).finally(() => this.setState({ isLoading: false }));
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_from = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_to = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_from;
                delete query.created_date_to;
            }
        }
        if (name === 'result_updated') {
            if (value && value.length > 0) {
                query.result_updated_from = moment(value[0]).format('YYYY-MM-DD');
                query.result_updated_to = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.result_updated_from;
                delete query.result_updated_to;
            }
        }
        delete query.result_updated;
        delete query.created_at;
        query = cleanObject(query);
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onExport() {
        const { auth } = this.props;

        const query = qs.parse(this.props.location.search.slice(1));
        const exportFilters = { ...query };
        delete exportFilters.page;
        delete exportFilters.per_page;

        this.setState({ isLoadingExport: true });

        // Gọi API export nhưng không chờ quá trình tạo file hoàn tất.
        this.props.exportCustomerProspects(exportFilters)
            .catch(() => {
                NotificationManager.error(
                    'Có lỗi xảy ra trong quá trình gửi yêu cầu xuất file. Vui lòng thử lại sau.',
                    'Lỗi',
                    9000
                );
            })
            .finally(() => this.setState({ isLoadingExport: false }));

        this.setState({ isLoadingExport: false });
        NotificationManager.success(
            `Quá trình xuất file đang được thực hiện.
        File kết quả sẽ được gửi vào email ${auth.email} trong ít phút.`,
            'Thông báo',
            9000
        );
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onRemove() {
        this.props.deleteCustomerProspects(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }
    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá khách hàng này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.deleteCustomerProspects([id]).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentItem: data });
    }

    openDetail(record) {
        this.setState({ currentRecord: record, loadingDetail: true })
        this.props.getCustomerProspect(record.id).then(res => {
            this.setState({ loadingDetail: false })
            this.toggleOpenDetail(true, res);
        })
    }

    onCancel() {
        this.props.form.resetFields();
        this.setState({ selectedRowKeys: [] })
    }

    onSetMessage = (message, type) => {
        this.setState({ importResponseMessage: message, importResponseType: type })
    }

    loadWards(province_code) {
        if (province_code) {
            this.props.getListWards({ province_code: province_code }).then(res => {
                this.props.form.resetFields(['ward_code']);
                this.setState({ wards: res.data })
            })
        }
    }

    openCreateProfile(record) {
        this.setState({ currentRecord: record, loadingDetail: true });
        this.setState({ currentItem: record, isOpenFormCreateCustomer: true })
    }

    render() {
        var { customerList, pagination, list_name, users, filterData } = this.props;
        var { isLoading, isLoadingExport, selectedRowKeys,
            isOpenFormImport, isOpenForm,
            currentItem, isOpenDetail, loadingDetail,
            importResponseType, importResponseMessage,
            currentRecord, wards, isOpenFormCreateCustomer } = this.state;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;
        var query = qs.parse(this.props.location.search.slice(1));

        const listProvinces = filterData?.provinces;
        const customerGroups = filterData?.groups;
        const customerStatus = filterData?.statuses;

        const columns = [
            {
                title: '#',
                align: 'center',
                width: '50px',
                key: 'actions',
                render: (_, record) => (
                    <Button
                        size="small"
                        type="dashed"
                        className='btn-edit'
                        icon={<PlusOutlined />}
                        onClick={() => this.openCreateProfile(record)}
                        disabled={!checkPermission('customer', 'create')}
                    >
                        Tạo hồ sơ
                    </Button>
                )
            },
            {
                title: 'Mã KH',
                dataIndex: 'code',
                key: 'code',
                width: '140px',
                sorter: true,
                render: (text, record) => {
                    return (
                        <Paragraph style={{ margin: 0 }} copyable={
                            {
                                text: record ? record.code : null,
                                tooltips: false
                            }
                        }>
                            {text}
                        </Paragraph>
                    )
                }
            },
            {
                title: 'Họ và tên',
                dataIndex: 'full_name',
                key: 'full_name',
                width: '200px',
                render: (text, record) => {
                    return (
                        <Tooltip title="Xem chi tiết" placement="right">
                            <div className='color-primary item-action-btn' onClick={() => this.openDetail(record)}>
                                &nbsp;<strong>{record.full_name}</strong>
                            </div>
                        </Tooltip>
                    )
                }
            },
            {
                title: 'Mã thẻ mới',
                dataIndex: 'card_number_new',
                key: 'card_number_new',
                width: '180px',
                sorter: true,
                render: (text, record) => {
                    if (text) {
                        return (
                            <Paragraph style={{ margin: 0 }} copyable={
                                {
                                    text: record ? record.card_number_new : null,
                                    tooltips: false
                                }
                            }>
                                {text}
                            </Paragraph>
                        )
                    }
                }
            },
            {
                title: 'Mã thẻ cũ',
                dataIndex: 'card_number',
                key: 'card_number',
                width: '140px',
                sorter: true,
                render: (text, record) => {
                    if (text) {
                        return (
                            <Paragraph style={{ margin: 0 }} copyable={
                                {
                                    text: record ? record.card_number : null,
                                    tooltips: false
                                }
                            }>
                                {text}
                            </Paragraph>
                        )
                    }
                }
            },
            {
                title: 'Điện thoại',
                dataIndex: 'phone',
                width: '120px',
                key: 'phone',
                render: (text, record) => {
                    if (record?.phone) {
                        return (
                            <>
                                <HandlePhoneNumber
                                    permission={checkPermission('customer_prospect', 'phonenumber')}
                                    inputPinCode={checkPermission('customer_prospect', 'input_pin_code')}
                                    customer_id={record?.id}
                                    hiddenPhoneNumber={repeatPhoneNumber(text)}
                                    fullPhoneNumber={text}
                                />
                            </>
                        )
                    }
                }
            },
            {
                title: 'Trạng thái',
                dataIndex: 'customer_status',
                key: 'customer_status',
                width: '200px',
                render: (text, record) => {
                    if (record.customer_status?.text_color) {
                        return (
                            <Tag color={record.customer_status?.text_color}>{record.customer_status?.name}</Tag>
                        )
                    } else {
                        return (<Tag>{text}</Tag>)
                    }
                }
            },
            {
                title: 'Kết quả tư vấn',
                dataIndex: 'result_note',
                key: 'result_note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={2} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Tỉnh/Thành phố',
                dataIndex: 'province_name',
                key: 'province_name',
                width: '140px'
            },
            {
                title: 'Phường/Xã',
                dataIndex: 'wards_name',
                key: 'wards_name',
                width: '140px'
            },
            {
                title: 'Tổ',
                dataIndex: 'residential_group',
                key: 'residential_group',
                width: '100px'
            },
            {
                title: 'Địa chỉ',
                dataIndex: 'address',
                key: 'address',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Năm sinh',
                dataIndex: 'birthday',
                key: 'birthday',
                width: '100px',
                sorter: true,
                render: (text, record) => {
                    return (
                        <>{text}</>
                    )
                }
            },
            {
                title: 'Giới tính',
                dataIndex: 'gender',
                key: 'gender',
                width: '90px',
                sorter: true,
                render: (text, record) => {
                    return (
                        <span style={{ textTransform: 'capitalize' }}>{text}</span>
                    )
                }
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={2} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Danh sách',
                dataIndex: 'list_name',
                key: 'list_name',
                width: '150px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Hồ sơ',
                dataIndex: 'has_profile',
                key: 'has_profile',
                width: '150px',
                sorter: true,
                render: (text, record) => {
                    return (
                        <>{renderProfileStatus(record.has_profile)}</>
                    )
                }
            },
            {
                title: 'Ngày telesale',
                dataIndex: 'result_updated_at',
                key: 'result_updated_at',
                width: '140px',
                sorter: true,
                render: (text, record) => {
                    if (text) {
                        return (
                            <div>{isValidDate(text, true)}</div>
                        )
                    }
                }
            },
            {
                title: 'Nhân viên telesale',
                dataIndex: 'result_updated_user',
                key: 'result_updated_user',
                width: '250px',
                render: (text, record) => {
                    return (
                        <CreatedAtCell
                            createdAt={record?.result_updated_at}
                            user={record?.result_updated_user}
                        />
                    )
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '220px',
                render: (text, record) => (
                    <CreatedAtCell
                        createdAt={text}
                        user={record?.created_user}
                    />
                )
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Khách hàng tiềm năng" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('customer_prospect', 'create')}
                        isShowDeleteButton={checkPermission('customer_prospect', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        activeFilter={
                            query.created_at ||
                            query.result_updated_from ||
                            query.province_code ||
                            query.ward_code ||
                            query.customer_status_id ||
                            query.result_updated_by ||
                            query.group_id ||
                            query.has_profile ||
                            query.phone_status ||
                            query.list_name_code
                        }
                        filters={
                            [<BaseSelect
                                options={list_name || []}
                                optionValue="list_name_code"
                                optionLabel="list_name"
                                showSearch
                                placeholder="Danh sách"
                                onChange={(value) => this.onChangeFilter('list_name_code', value)}
                                className="w-100"
                                defaultValue={query.list_name_code ? query.list_name_code : null}
                            />,
                            <BaseSelect
                                options={customerGroups || []}
                                showSearch
                                optionValue="id"
                                optionLabel="name"
                                placeholder="Nhóm"
                                onChange={(value) => this.onChangeFilter('group_id', value)}
                                className="w-100"
                                defaultValue={query.group_id ? parseInt(query.group_id) : null}
                            />,
                            <BaseSelect
                                options={profileStatusOptions || []}
                                showSearch
                                placeholder="Hồ sơ"
                                onChange={(value) => this.onChangeFilter('has_profile', value)}
                                className="w-100"
                                defaultValue={query.has_profile ? query.has_profile : null}
                            />,
                            <BaseSelect
                                options={[
                                    { value: 'has_phone', label: 'Có số điện thoại' },
                                    { value: 'no_phone', label: 'Không có số điện thoại' }
                                ]}
                                defaultText="Tất cả"
                                placeholder="Trạng thái số điện thoại"
                                onChange={(value) => this.onChangeFilter('phone_status', value)}
                                className="w-100"
                                defaultValue={query.phone_status ? query.phone_status : null}
                            />,
                            <RangePicker
                                format="DD/MM/YYYY"
                                placeholder={['Ngày', 'telesale']}
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('result_updated', value)}
                                defaultValue={[query.result_updated_from ? moment(query.result_updated_from, 'YYYY-MM-DD') : null, query.result_updated_to ? moment(query.result_updated_to, 'YYYY-MM-DD') : null]}
                            />,
                            <BaseSelect
                                options={users || []}
                                optionValue="user_id"
                                optionLabel="display_name"
                                showSearch
                                placeholder="Nhân viên telesale"
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('result_updated_by', value)}
                                defaultValue={query.result_updated_by ? parseInt(query.result_updated_by) : null}
                            />,
                            <BaseSelect
                                options={customerStatus || []}
                                optionValue="id"
                                optionLabel="name"
                                showSearch
                                placeholder="Trạng thái khách hàng"
                                onChange={(value) => this.onChangeFilter('customer_status_id', value)}
                                className="w-100"
                                defaultValue={query.customer_status_id ? parseInt(query.customer_status_id) : null}
                            />,
                            <BaseSelect
                                options={listProvinces || []}
                                optionValue="code"
                                optionLabel="name"
                                showSearch
                                placeholder="Tỉnh/Thành phố"
                                className="w-100"
                                onChange={(value) => {
                                    this.onChangeFilter('province_code', value);
                                    this.loadWards(value)
                                }}
                                defaultValue={query.province_code ? query.province_code : null}
                            />,
                            <BaseSelect
                                options={wards || []}
                                optionValue="code"
                                optionLabel="name"
                                showSearch
                                placeholder="Phường/Xã"
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('ward_code', value)}
                                defaultValue={query.ward_code ? query.ward_code : null}
                            />
                            ]
                        }
                    >
                        {
                            checkPermission('customer_prospect', 'import_excel') ? (
                                <Button className="table-button" type="dashed" onClick={() => this.setState({ isOpenFormImport: true })}>Import excel</Button>
                            ) : null
                        }

                        {
                            checkPermission('customer_prospect', 'export') ? (
                                <Button className="table-button" loading={isLoadingExport} onClick={() => this.onExport()} icon={<ExportOutlined />}>Export</Button>
                            ) : null
                        }

                        <RangePicker
                            format="DD/MM/YYYY"
                            placeholder={['Ngày tạo', 'Đến ngày']}
                            style={{ width: '220px' }}
                            className="table-button"
                            onChange={(value) => this.onChangeFilter('created_at', value)}
                            defaultValue={[query.created_date_from ? moment(query.created_date_from, 'YYYY-MM-DD') : null, query.created_date_to ? moment(query.created_date_to, 'YYYY-MM-DD') : null]}
                        />
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                <div>
                    {
                        importResponseMessage && importResponseType ? (
                            <Alert
                                message={importResponseMessage}
                                type={importResponseType}
                                className="mb-2 mt-2"
                                closable
                                onClose={() => this.onSetMessage(null, null)}
                            />
                        ) : null
                    }
                </div>
                <div className='has-custom-column-table-btn'>
                    <DynamicTable
                        rowKey="id"
                        dataSource={customerList || []}
                        columns={columns}
                        isLoading={isLoading}
                        pagination={pagination}
                        rowSelection={rowSelection}
                        moduleKey="customer_prospects"
                        className='has-table-summary'
                        onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
                    />
                </div>
                <CustomerProspectForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => false}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <CustomerProspectDetail
                    visible={isOpenDetail}
                    currentItem={currentItem}
                    reloadData={() => this.openDetail(currentRecord)}
                    onCancel={() => this.toggleOpenDetail(false)}
                    loadingDetail={loadingDetail}
                />
                <ImportExcelForm
                    visible={isOpenFormImport}
                    onCancel={() => this.setState({ isOpenFormImport: false })}
                    onSetMessage={this.onSetMessage}
                    reloadData={() => this.loadData()}
                />
                <CreateProfileForm
                    visible={isOpenFormCreateCustomer}
                    currentItem={currentItem}
                    reloadData={() => this.loadData()}
                    onCancel={() => this.setState({ isOpenFormCreateCustomer: false })}
                />
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {
        customerList: state.customerProspectsReducer.list.items,
        pagination: state.customerProspectsReducer.list.pagination,
        list_name: state.customerProspectsReducer.names.items,
        users: state.config.users,
        auth: state.auth.authUser,
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getCustomerProspects: (filter) => dispatch(getCustomerProspects(filter)),
        deleteCustomerProspects: (ids) => dispatch(deleteCustomerProspects(ids)),
        getListWards: (filter) => dispatch(getListWards(filter)),
        getCustomerProspectNames: (filter) => dispatch(getCustomerProspectNames(filter)),
        getCustomerProspect: (id) => dispatch(getCustomerProspect(id)),
        exportCustomerProspects: (filter) => dispatch(exportCustomerProspects(filter)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerProspectList' })(CustomerProspectList));

